import type { CarUpgrade } from "./CarStats.js";

export const CAR_PRESETS: Record<string, CarUpgrade> = {
  stock: {
    engine: 0, gearbox: 0, turbo: 0, suspension: 0, aero: 0, brakes: 0, boost: 0,
  },
  balanced: {
    engine: 1, gearbox: 1, turbo: 0, suspension: 1, aero: 0, brakes: 1, boost: 0,
  },
  speed: {
    engine: 3, gearbox: 2, turbo: 2, aero: 1, suspension: 0, brakes: 0, boost: 1,
  },
  grip: {
    engine: 1, gearbox: 1, turbo: 0, suspension: 3, aero: 3, brakes: 2, boost: 0,
  },
  drift: {
    engine: 2, gearbox: 2, turbo: 1, suspension: 0, aero: 0, brakes: 1, boost: 2,
  },
  combat: {
    engine: 2, gearbox: 0, turbo: 3, suspension: 1, aero: 1, brakes: 2, boost: 3,
  },
  lightweight: {
    engine: 1, gearbox: 3, turbo: 0, suspension: 2, aero: 0, brakes: 3, boost: 0,
  },
};
